import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';

import { switchSiteTheme } from 'Redux/ducks/site-theme';

const messages = defineMessages({
  lighttheme: {
    id: 'account-theme.lighttheme',
    defaultMessage: 'Light Theme',
  },
  darktheme: {
    id: 'account-theme.darktheme',
    defaultMessage: 'Dark Theme',
  },
});

const AccountTheme = ({ siteTheme, intl }) => {
  const { formatMessage } = intl;
  const [theme, setTheme] = useState(siteTheme === 'light');
  useEffect(() => {
    const themeString = theme ? 'light' : 'dark';
    switchSiteTheme(themeString);
  }, [theme]);

  return (
    <div className="account-table-row">
      <div className="account-table-row-title">
        <FormattedMessage id="account-theme.title" defaultMessage="Site Theme" />
      </div>
      <div className="account-table-row-content">
        <div className="account-table-details-container">
          {siteTheme === 'dark' ? formatMessage(messages.darktheme) : formatMessage(messages.lighttheme)}
        </div>
        <div className="account-table-action-container">
          {siteTheme === 'dark' &&
            <button type="button" className="account-table-action-button" onClick={() => setTheme(true)}>
              <FormattedMessage id="account-theme.button.change" defaultMessage="Change Theme" />
            </button>
          }
          {siteTheme === 'light' &&
            <button type="button" className="account-table-action-button" onClick={() => setTheme(false)}>
              <FormattedMessage id="account-theme.button.change" defaultMessage="Change Theme" />
            </button>
          }
        </div>
      </div>
    </div>
  );
};

AccountTheme.propTypes = {
  siteTheme: PropTypes.string,
};

AccountTheme.defaultProps = {
  siteTheme: 'dark',
};

const mapStateToProps = ({
  siteTheme,
}) => ({
  siteTheme,
});


export default connect(mapStateToProps)(injectIntl(AccountTheme));
